<div>
  <ng-template #openerTemplate>
    <button (click)="toggle()" (keydown.enter)="toggle()" class="account-menu">
      <ftr-icon-legacy align="Bottom" icon="AccountCircle" />
      @if (isXLarge) {
        <span class="account-menu__name" [attr.aria-label]="'Account Menu for ' + (userFullName$ | async)">{{
          userFullName$ | async
        }}</span>
      }
      <ftr-icon-legacy align="Bottom" icon="ChevronDown" />
    </button>
  </ng-template>

  @if (!isMobile) {
    <ftr-dropdown-menu-legacy
      ariaLabel="Account dropdown menu"
      [menuItems]="(accountMenuItems$ | async) ?? []"
      [openerTemplate]="openerTemplate"
      data-track-group="Account Dropdown"
    />
  }

  @if (isMobile) {
    <ftr-side-nav
      [headerTemplate]="accountTemplate"
      [navItems]="accountMenuItems$"
      [openerTemplate]="openerTemplate"
      data-track-group="Account Side Nav"
      openFrom="right"
    />
  }

  <ng-template #accountTemplate>
    <a (click)="toggle()" [routerLink]="['/account']" class="account-menu__account">
      <ftr-icon-legacy gapRight="Regular" align="Bottom" color="Primary" icon="AccountCircle" />
      {{ userFullName$ | async }}
    </a>
  </ng-template>
</div>
